import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { ECA_ENVIRONMENT_APP_INITIALIZER_PROVIDER } from './app/services/environment/environment.service';
import { ECA_SECURITY_AUTHENTICATION_APP_INITIALIZER_PROVIDER } from './app/services/security-authentication/security-authentication.service';
import { ECA_PORTAL_HEADER_LOADER_APP_INITIALIZER_PROVIDER } from './app/services/portal-header-lib-loader/portal-header-lib-loader.service';
import { ECA_JWT_HTTP_INTERCEPTOR_PROVIDER } from './app/services/jwt-interceptor/jwt-interceptor';
import { JQUERY_PROVIDER } from './app/services/jquery-provider/jquery-provider';
import { APP_BASE_HREF_HASHBANG, AppRoutingModule } from './app/app-routing.module';
import { SharedModule } from './app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AlertModule } from 'ngx-bootstrap/alert';
import { EcaComponentsLibModule, EcaSiteSearchModule, EcaIconModule, EcaAppShellModule, EcaPaginatorModule, EcaSnackbarAlertModule, ECA_DATEPICKER_FORMAT, EcaDateAdapter } from '@drc-eca/eca-components-lib';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { MatCardModule } from '@angular/material/card';
import { AppComponent } from './app/app.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

function tokenGetter() {
  const token = sessionStorage.getItem('ngStorage-ecatoken');
  try {
    return JSON.parse(token as string);
  } catch {
    return token;
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(SharedModule, AppRoutingModule, RouterModule, BrowserModule, FormsModule, ReactiveFormsModule, FlexLayoutModule, AlertModule.forRoot(), EcaComponentsLibModule.forRoot(environment.apiGatewayConfig), EcaSiteSearchModule, EcaIconModule, EcaAppShellModule, EcaPaginatorModule, CommonModule, MatSnackBarModule, MatExpansionModule, MatChipsModule, MatTableModule, MatCheckboxModule, MatButtonModule, MatDialogModule, MatSortModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatIconModule, MatProgressSpinnerModule, EcaSnackbarAlertModule, MatTabsModule, JwtModule.forRoot({
            config: { tokenGetter }
        }), MatTableModule, MatCardModule),
        ECA_ENVIRONMENT_APP_INITIALIZER_PROVIDER,
        ECA_SECURITY_AUTHENTICATION_APP_INITIALIZER_PROVIDER,
        ECA_PORTAL_HEADER_LOADER_APP_INITIALIZER_PROVIDER,
        ECA_JWT_HTTP_INTERCEPTOR_PROVIDER,
        JQUERY_PROVIDER,
        APP_BASE_HREF_HASHBANG,
        { provide: MAT_DATE_FORMATS, useValue: ECA_DATEPICKER_FORMAT },
        { provide: DateAdapter, useClass: EcaDateAdapter, deps: [MAT_DATE_LOCALE] },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.log(err));
